import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { path } from "../../../../constants/path";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import RoleControlPanel from "../../components/ControlPanel/RoleControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import Pagination from "src/components/Pagination/Pagination";
import RoleTable from "../../components/Table/RoleTable";
import { Notify, NotifyConfirm, Toast } from "src/components/notify/Notify";
import { deleteRole, getRoles } from "src/apis/System/role.api";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";

const initRoleData = { list: [], total_record: 0 };

const titlePage = "Role";

const Roles = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();
  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [roleData, setRoleData] = useState(initRoleData);

  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };
    getRoles(query, (result) => {
      setRoleData({ ...result });
    });
  }, [endDate, limit, numberPage, page, search, startDate, status]);

  const handleDelete = (roleDelete) => {
    if (roleDelete.employees.length || roleDelete.departments.length) {
      Toast("warning", "Role đang được dùng, không thể xóa");
    } else {
      NotifyConfirm("warning", "Are you delete it ?", (result) => {
        if (result.isConfirmed) {
          // * Ưu tiên render giao diện trước
          const roleDataFilter = roleData.list.filter(
            (role) => role.id !== roleDelete.id
          );
          setRoleData((prev) => {
            return {
              ...prev,
              list: [...roleDataFilter],
            };
          });
          Notify("success", "Deleted!");

          // * Sau đó mới gọi API remove role
          deleteRole(roleDelete.id);
        }
      });
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <RoleControlPanel permissionsAccessControl={permissionsAccessControl}>
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </RoleControlPanel>

      <RoleTable
        permissionsAccessControl={permissionsAccessControl}
        data={roleData?.list || []}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.systemRole}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={roleData.total_record}
      />
    </div>
  );
};

export default Roles;
